import React from "react";
import { useSelectedPage } from "../../../hook";
import {
  useFetchPullConnectorListener,
  useGetConnector,
  usePullConnectorPath,
  usePullConnectorRouteParamListener,
  usePullConnectorTableRouteParamListener,
  useSelectedPullConnector,
  useSelectedPullConnectorTable,
} from "../../../hook/pullConnector";
import { useTable } from "../../../hook/table";
import {
  NoteBlockContainer,
  NoteBlockContainerLegacy,
  NotePageContainer,
} from "../../note";
import { SearchTable } from "../../searchTable";
import { GoBackButton } from "../../goBack";

export const PullConnectorTablePage: React.FC = () => {
  usePullConnectorTableRouteParamListener();
  usePullConnectorRouteParamListener();
  useFetchPullConnectorListener();
  const [selectedPullConnectorId, setSelectedPullConnectorId] =
    useSelectedPullConnector();
  const {
    selectedPullConnectorTable: table,
    selectedPullConnectorTableId: tableId,
  } = useSelectedPullConnectorTable();
  const tableName = table?.name ?? "";
  const pullConnectorPath = usePullConnectorPath();

  return (
    <>
      <GoBackButton href={pullConnectorPath(selectedPullConnectorId)} />
      <NotePageContainer pageName={tableName}>
        <NoteBlockContainer name={tableName}>
          <SearchTable tableId={tableId} />
        </NoteBlockContainer>
      </NotePageContainer>
    </>
  );
};
